import { builder } from "@builder.io/react";
import "./register.tsx";

builder.init("cb2dbb86d5924a0faeaf115b3c0c335a");
